import React from 'react'
import { Route, Redirect } from 'react-router-dom'

import { useLogin, usePermissions } from '../hooks'

const PrivateRoute = ({
  component: Component,
  requiredPermissions,
  ...rest
}) => {
  const [{ isLoggedIn }] = useLogin()
  const permissions = usePermissions(requiredPermissions || [])

  const allowed = isLoggedIn && permissions.every((p) => p)
  return (
    <Route
      {...rest}
      render={(props) =>
        allowed ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{ pathname: '/login', state: { from: props.location } }}
          />
        )
      }
    />
  )
}

export default PrivateRoute
